// T008 — option lists + medical-question config for the Patient & Order Info modal.
// These are display/bookkeeping fields (mostly stored in pacs_orders.po_extra_info);
// nothing else queries them, so the option sets live here rather than a master table.

// Patient Type maps to the real column po_pat_class ("Reg. Type"), which stores
// HL7 patient-class codes. Values here MUST be the stored codes (O/I/E) so
// existing orders prefill correctly and MIS reports / the Reg.Type column
// (resolveRegistrationType: O→OPD, I→IPD, E→Emergency) stay consistent.
export const PATIENT_TYPE_OPTIONS = [
  { value: 'O', label: 'OPD' },
  { value: 'I', label: 'IPD' },
  { value: 'E', label: 'Emergency' },
];

// Impairment is free-form in old PACS; we offer a small starter list + free entry.
export const IMPAIRMENT_OPTIONS = [
  { value: 'None', label: 'None' },
  { value: 'Hearing', label: 'Hearing' },
  { value: 'Vision', label: 'Vision' },
  { value: 'Speech', label: 'Speech' },
  { value: 'Mobility', label: 'Mobility' },
  { value: 'Cognitive', label: 'Cognitive' },
  { value: 'Other', label: 'Other' },
];

// Yes / No / NA tri-state used by every Medical Information row.
export const YES_NO_NA_OPTIONS = [
  { value: 'YES', label: 'Yes' },
  { value: 'NO', label: 'No' },
  { value: 'NA', label: 'NA' },
];

// Medical Information rows. `key` is the field stored under po_extra_info.med.
export const MEDICAL_QUESTIONS = [
  { key: 'metformin', label: 'Is patient taking Metformin?' },
  { key: 'allergies', label: 'Does the patient have any allergies?' },
  { key: 'diabetic', label: 'Is patient diabetic?' },
  { key: 'verified_id', label: 'Verified patient Id, part and side?' },
  { key: 'metal_removed', label: 'Is the Metal or Ornament Removed?' },
  { key: 'pregnancy', label: 'Pregnancy' },
];
